import React, { useState } from 'react';
import iconAdd from '../../../assets/images/icon-add-square.svg';
import { MdKeyboardArrowDown, MdOutlineClose } from 'react-icons/md';
import { FilterSelectStyle } from './TasksPreviewSection.styles';
import { GoPlus } from 'react-icons/go';

const FilterSelect = ({ title, selectedOptions = [], onChange, options = [], isInput }) => {
  const [isActive, setIsActive] = useState(false);
  const [isSelectActive, setIsSelectActive] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const [selectedOption, setSelectedOption] = useState('');

  const handleToggle = () => {
    setIsActive(prev => !prev);
  };

  const handleSelectClick = () => {
    setIsSelectActive(prev => !prev);
  };

  const handleOptionClick = option => {
    setSelectedOption(option);
    setIsSelectActive(false);
  };

  const handleClearSelection = option => {
    onChange(
      selectedOptions.filter(opt => {
        if (Array.isArray(opt) && Array.isArray(option)) {
          return !(opt[0] === option[0] && opt[1] === option[1]);
        }
        return opt !== option;
      }),
    );
  };

  const handleAddClick = () => {
    if (!selectedOption) return;

    if (isInput) {
      if (!inputValue.trim()) return; // don't add empty
      // Store as [operator, value]
      onChange([...selectedOptions, [selectedOption, inputValue.trim()]]);
    } else {
      // Store as simple string
      onChange([...selectedOptions, selectedOption]);
    }

    setSelectedOption('');
    setInputValue('');
    setIsSelectActive(false);
    setIsActive(false);
  };

  return (
    <FilterSelectStyle className={isActive ? 'active' : ''}>
      <div className="filter-opener" onClick={handleToggle}>
        {title}
        <img src={iconAdd} width="20" alt="add" />
      </div>
      <div className="selected-options">
        {selectedOptions.map((option, idx) => {
          // Handle both array (for input filters) and string (for predefined)
          const display = Array.isArray(option) ? `${option[0]}: ${option[1]}` : option;

          return (
            <div key={idx} className="selected-option option-text option-active">
              {display}
              <MdOutlineClose className="icon" onClick={() => handleClearSelection(option)} />
            </div>
          );
        })}
      </div>

      <div className={`filter-wrapper`}>
        <div className={`select-wrap ${isSelectActive ? 'select-active' : ''}`}>
          <div>
            <div className="filter-select" onClick={handleSelectClick}>
              <span className="select-text">{selectedOption ? selectedOption : 'Select'}</span>
              <MdKeyboardArrowDown size={22} />
            </div>
            {isSelectActive && (
              <div className="custom-option">
                {options?.map(opt => (
                  <span key={opt} className="option-text" onClick={() => handleOptionClick(opt)}>
                    {opt}
                  </span>
                ))}
              </div>
            )}
          </div>
          {isInput && (
            <input
              type="text"
              value={inputValue}
              placeholder="Type in your search"
              onChange={e => setInputValue(e.target.value)}
              className="text-input"
            />
          )}
          <button className="add-icon" onClick={handleAddClick}>
            <GoPlus size={20} />
          </button>
        </div>
        <MdOutlineClose className="icon" size={20} onClick={() => setIsActive(false)} />
      </div>
    </FilterSelectStyle>
  );
};

export default FilterSelect;
